/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { Container, Divider, Form, Grid, Icon } from 'semantic-ui-react';
import moment from 'moment';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as qs from 'qs/lib';
import { Link } from 'react-router-dom';
import ajax from '../../Services/LoginService';
import * as profileActions from '../../Actions/actions_profile';
import * as userActions from '../../Actions/actions_user';
import Helpers from '../Utils/Helpers';
// Commented out as part of ticket to remove Google SSO
// import SocialLoginOptions from './SocialLoginOptions';
import LoginService from '../../Services/LoginService';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      value: '',
      reset_password_view: false,
      verification_code_view: false,
      reset_email: '',
      // remember: !!localStorage.getItem('remember-me'),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.sendPasswordResetRequest = this.sendPasswordResetRequest.bind(this);
    this.successNavigation = this.successNavigation.bind(this);
  }

  successNavigation() {
    const parsed = qs.parse(
      this.props.location.search.slice(1, this.props.location.search.length)
    );
    let url = '/dashboard';
    if ('redirect' in parsed) url = parsed.redirect;
    this.props.history.push(url);
  }

  sendPasswordResetRequest(event) {
    const that = this;
    event.preventDefault();
    const email = document.getElementById('email').value;
    ajax
      .sendPasswordReset(email)
      .then((data) => {
        Helpers.createToast(data);
        that.setState({
          reset_password_view: false,
          verification_code_view: false,
          reset_email: email,
          email,
        });
      })
      .catch((data) => {
        Helpers.createToast(data);
        that.setState({
          reset_password_view: true,
          verification_code_view: false,
          reset_email: email,
          email,
        });
      });
  }

  handleChange(event) {
    const key = event.target.id;

    if (key === 'email') {
      this.setState({
        email: event.target.value,
      });
    } else if (key === 'password') {
      this.setState({
        password: event.target.value,
      });
    } else {
      this.setState({
        value: event.target.value,
      });
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.user && this.props.user.date_register_finished) {
      this.successNavigation();
    } else if (this.props.user && !this.props.user.date_register_finished) {
      this.props.history.push('/register');
    } else {
      this.props.updateUser(false, false, true);
    }
    // TODO: Should not use _mounted. https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
    this._mounted = true;
  }

  componentWillUnmount() {
    // TODO: Should not use _mounted. https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
    this._mounted = false;
  }

  /* onChangeRemember = () => {
    const { remember } = this.state;
    if (remember) {
      localStorage.removeItem('remember-me');
    } else {
      localStorage.setItem('remember-me', true);
    }
    this.setState(prevState => ({
      remember: !prevState.remember,
    }));
  };
  */

  handleSubmit(event) {
    const that = this;
    this.setState({ displayLoginErrors: false });
    ajax
      .login(this.state.email, this.state.password)
      .then(async (data) => {
        return LoginService.afterUserLogin(data, `login-gmb`, that.props);
      })
      .catch((error) => {
        toast.error(`Invalid credentials. ${error.error_description || ''}`);
        that.setState({ displayLoginErrors: true });
      });

    event.preventDefault();
  }

  renderResetPassword() {
    if (this.state.reset_password_view) {
      return (
        <div>
          <h2
            style={{
              textAlign: 'center',
              width: '100%',
              marginTop: '20px',
              marginBottom: '20px',
            }}
          >
            Reset Password
          </h2>
          <Form onSubmit={this.sendPasswordResetRequest}>
            <Form.Field>
              <label>E-Mail Address</label>
              <input
                id="email"
                type="email"
                className="form-control data-hj-whitelist"
                name="email"
                onChange={this.handleChange}
                required
                autoFocus
              />
            </Form.Field>
            <Form.Field style={{ textAlign: 'center', marginTop: '30px' }}>
              <Form.Button color="twitter">Reset Password</Form.Button>
            </Form.Field>
          </Form>
        </div>
      );
    }
    return <div />;
  }

  render() {
    return (
      <React.Fragment>
        <div
          className="login-container login"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Grid centered>
            <Grid.Column mobile={16} tablet={6} computer={8}>
              <Container>
                {this.renderResetPassword()}
                <div
                  style={{
                    display:
                      this.state.reset_password_view ||
                      this.state.verification_code_view
                        ? 'none'
                        : '',
                  }}
                >
                  <h2
                    style={{
                      textAlign: 'center',
                      width: '100%',
                      marginBottom: '20px',
                    }}
                    className="login_title"
                  >
                    Login
                  </h2>
                  <Form onSubmit={this.handleSubmit}>
                    <Form.Field>
                      <input
                        id="email"
                        placeholder="Email"
                        type="email"
                        className={`form-control data-hj-whitelist ${
                          this.state.displayLoginErrors && 'is-invalid'
                        }`}
                        // style={{ width: '300px' }}
                        name="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        required
                        autoFocus
                      />
                    </Form.Field>
                    <Form.Field>
                      <input
                        id="password"
                        type="password"
                        data-private
                        placeholder="Password"
                        className={`form-control ${
                          this.state.displayLoginErrors && 'is-invalid'
                        }`}
                        style={{ width: '300px' }}
                        name="password"
                        value={this.state.password}
                        onChange={this.handleChange}
                        required
                      />
                    </Form.Field>
                    {/* <Form.Field>
                      <Checkbox
                        label="Remember me"
                        onChange={this.onChangeRemember}
                        checked={this.state.remember}
                      />
                    </Form.Field> */}
                    <div className="login_button_container">
                      <Form.Button color="twitter" className="login_button">
                        Login <Icon name="angle right" />
                      </Form.Button>
                      <div className="forgot_password">
                        <a
                          onClick={() =>
                            this.setState({ reset_password_view: true })
                          }
                        >
                          Forgot your password?
                        </a>
                      </div>
                    </div>
                    {/* <SocialLoginOptions action={'login'} {...this.props} /> */}
                  </Form>
                </div>
                <p className="register text-center">
                  Don't have an account?{' '}
                  <a
                    onClick={() => {
                      LoginService.routeWithParams('signup', this.props);
                    }}
                  >
                    Sign up
                  </a>
                </p>
              </Container>
            </Grid.Column>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(null, {
  fetchUserData: userActions.fetchUserData,
  fetchUserInformation: profileActions.fetchUserInformation,
  fetchUserAbout: profileActions.fetchUserAbout,
  fetchUserPreferences: profileActions.fetchUserPreferences,
  fetchUserCategories: profileActions.fetchUserCategories,
  fetchUserSubscription: userActions.fetchUserSubscription,
})(Login);
